import { VehicleLicenseTypeDto } from '../../pages/users/api/dto/get/VehicleLicenseTypeDto'
import { VehicleLicenseTypesDto } from '../../pages/users/api/dto/get/VehicleLicenseTypesDto'
import VehicleLicenseType from './VehicleLicenseType'

class VehicleLicenseTypes {
  private constructor(vehicleLicenses: VehicleLicenseType[]) {
    this.vehicleLicenses = vehicleLicenses
  }

  private readonly vehicleLicenses: VehicleLicenseType[]

  isEmpty(): boolean {
    return this.vehicleLicenses.length === 0
  }

  getAll(): VehicleLicenseType[] {
    return this.vehicleLicenses
  }

  static empty(): VehicleLicenseTypes {
    return new VehicleLicenseTypes([])
  }

  static fromDto(
    vehicleLicenseTypesDto: VehicleLicenseTypesDto,
  ): VehicleLicenseTypes {
    const vehicleLicenseTypes = vehicleLicenseTypesDto.vehicleLicenses.map(
      (vehicleLicenseTypeDto: VehicleLicenseTypeDto) =>
        VehicleLicenseType.fromDto(vehicleLicenseTypeDto),
    )

    return new VehicleLicenseTypes(vehicleLicenseTypes)
  }
}

export default VehicleLicenseTypes
